import React from 'react';
import ReactDOM from 'react-dom';
import styles from '../ConfirmationPopUp/ConfirmationPopUp.module.css';
import buttonStyles from '../YesNoButtonsCSS/YesNoButtons.module.css';

const StructuralSpecSuccessModal = ({ isVisible, onClose }) => {
    if (!isVisible) return null;

    return ReactDOM.createPortal(
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={e => e.stopPropagation()} style={{ width: '450px' }}>
                <p className={styles.text} style={{ fontSize: '16px', lineHeight: '1.5' }}>
                    The Structural Specification has been successfully generated and saved to SharePoint.
                    <br /><br />
                    You will also receive an email with the PDF version shortly.
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <div style={{ width: '100px', height: '30px' }}>
                        <button onClick={onClose} className={buttonStyles.YesButtonComponentStyling}>
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default StructuralSpecSuccessModal;
